import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/roomHeat.png'


const _withScopeId = n => (_pushScopeId("data-v-297fd59a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "anchor-centen-box" }
const _hoisted_4 = { class: "anchor-centen-box-top" }
const _hoisted_5 = {
  key: 0,
  class: "livegif"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "livegif"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "livegif"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 3,
  class: "livegif"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "anchor-centen-box-bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_16 = { class: "anchor-centen-bottem" }
const _hoisted_17 = { class: "ovehide" }
const _hoisted_18 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.title,
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <div class=\"anchor-centen\" v-for=\"(item, index) in data\" :key=\"index\" @click=\"toLiveRoom(item)\">\r\n        <div class=\"anchor-centen-box\">\r\n          <van-image fit=\"cover\" lazy-load v-if=\"item.screen_shots && item.screen_shots.length > 0\"\r\n            :src=\"item.screen_shots\" alt=\"\" />\r\n          <van-image fit=\"cover\" lazy-load v-else :src=\"item.room_cover\" alt=\"\" />\r\n          <div class=\"anchor-centen-box-top\">\r\n            <div>\r\n              <template v-if=\"index < 2 && item.room_id && item.room_id > 0\">\r\n                <img v-lazy=\"guanfangtuijian\" alt=\"\" />\r\n              </template>\r\n            </div>\r\n            <div class=\"nchor-centen-box-top-right flexcenter\">\r\n              <img v-lazy=\"ren_icon\" alt=\"\" />\r\n              <p>{{ formatNum(item.heat) }}</p>\r\n            </div>\r\n          </div>\r\n          <div class=\"anchor-centen-box-bottom\">\r\n            <div></div>\r\n            <div>\r\n              <img src=\"@/assets/images/roomHeat.png\" alt=\"\">\r\n              <span>{{ item.heat }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"anchor-centen-bottem\">\r\n          <p class=\"ovehide\">{{ item.room_title }}</p>\r\n          <p v-if=\"item.nickName && item.nickName !==''\">{{item.nickName}}</p>\r\n        </div>\r\n      </div> "),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "anchor-centen",
          key: index,
          onClick: ($event: any) => ($setup.toLiveRoom(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" <van-image fit=\"cover\" lazy-load v-if=\"item.screen_shots && item.screen_shots.length > 0\"\r\n            :src=\"item.screen_shots\" alt=\"\" /> "),
            _createVNode(_component_van_image, {
              fit: "cover",
              "lazy-load": "",
              src: item.room_cover,
              alt: ""
            }, null, 8 /* PROPS */, ["src"]),
            _createElementVNode("div", _hoisted_4, [
              ($setup.checkZb(item) == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      class: "gif1",
                      src: $setup.livezb,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_6)
                  ]))
                : ($setup.checkZb(item) == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "gif2",
                        src: $setup.liveqy,
                        alt: ""
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                  : ($setup.checkZb(item) == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("img", {
                          class: "gif2",
                          src: $setup.livepb,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_10)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("img", {
                          class: "gif3",
                          src: $setup.livejj,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_12)
                      ])),
              _createCommentVNode(" <img v-if=\"item.room_id\" class=\"png\" :src=\"livetj\" alt=\"\"> ")
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createCommentVNode(" <van-image fit=\"cover\" lazy-load :src=\"item.portrait\" /> "),
              _hoisted_14,
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(item.heat), 1 /* TEXT */)
              ])
            ])
          ]),
          _createCommentVNode(" roomHeat.png "),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(item.room_title), 1 /* TEXT */),
            (item.nickName && item.nickName !== '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(item.nickName), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_2))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}